export default "/assets/images/crittercuddler-circle.fcfafd0be84faf3d.png";